import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import type { Metadata } from '@/types/v2/metadata';

import { SideNav } from './side-nav';
import { LayoutContainer } from '../layout-container';

interface LayoutProps {
  children: React.ReactNode;
  metadata: Metadata;
}

export function Layout({ children, metadata }: LayoutProps): React.JSX.Element {
  return (
    <LayoutContainer metadata={{ title: metadata.title }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ position: 'relative' }}>
        <SideNav />
        <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{children}</Box>
      </Stack>
    </LayoutContainer>
  );
}
